import { createAction } from 'redux-actions';
export var LOAD_OTHER_PASSENGER_TYPES = 'LOAD_OTHER_PASSENGER_TYPES';
export var SET_OTHER_PASSENGER_TYPES = 'SET_OTHER_PASSENGER_TYPES';
export var loadOtherPassengerTypes = createAction(LOAD_OTHER_PASSENGER_TYPES);
export var setOtherPassengerTypes = createAction(SET_OTHER_PASSENGER_TYPES, function (value) { return value; });
